import { CarrierVisitStatus, WorkInstructionStatus, WorkQueueStatus } from '@operations/app/api'

export const canStartWorkInstruction = (status: WorkInstructionStatus): boolean => {
  return status === WorkInstructionStatus.Pending || status === WorkInstructionStatus.Stopped
}

export const canStopWorkInstruction = (status: WorkInstructionStatus): boolean => {
  return status === WorkInstructionStatus.InProgress || status === WorkInstructionStatus.Todo
}

export const canStartWorkQueue = (
  status?: WorkQueueStatus,
  carrierVisitStatus?: CarrierVisitStatus,
): boolean => {
  return (
    (status === WorkQueueStatus.Pending || status === WorkQueueStatus.Stopped) &&
    carrierVisitStatus === CarrierVisitStatus.InOperation
  )
}

export const canStopWorkQueue = (
  status?: WorkQueueStatus,
  carrierVisitStatus?: CarrierVisitStatus,
): boolean => {
  return (
    (status === WorkQueueStatus.InProgress || status === WorkQueueStatus.Todo) &&
    carrierVisitStatus === CarrierVisitStatus.InOperation
  )
}
